import { render, staticRenderFns } from "./RCtrack.vue?vue&type=template&id=672aa234&scoped=true"
import script from "./RCtrack.vue?vue&type=script&lang=js"
export * from "./RCtrack.vue?vue&type=script&lang=js"
import style0 from "./RCtrack.vue?vue&type=style&index=0&id=672aa234&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672aa234",
  null
  
)

export default component.exports